export const snakeToPascal = input =>
  input.split('_').reduce((previous, current) => previous + current.charAt(0).toUpperCase() + current.slice(1), [])

export default snakeToPascal
